export type Matcher<Key, Value> = (key: Key) => Value;

// Enables the creation of pattern matchers simplifying the mapping of one data type
// to another
export default function match<Key, Value>(
  ...patterns: Array<[Key[] | Key, Value]>
): Matcher<Key, Value> {
  return (key: Key) => {
    for (const [patternKey, value] of patterns) {
      if (
        patternKey === key ||
        (Array.isArray(patternKey) && patternKey.includes(key))
      ) {
        return value;
      }
    }

    throw new Error(`Non exhaustive match, no match for "${key}"`);
  };
}
